/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-18 21:36:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-18 21:40:25
 */

module.exports = {
  roleList: [
    {
      label: "运维管理员",
      roleId: "10",
    },
    {
      label: "场地管理员",
      roleId: "11",
    },
    {
      label: "运营商负责人",
      roleId: "20",
    },
    {
      label: "超级管理员",
      roleId: "50",
    },
  ],
};
